/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPADDRESSTYPE = {
    PhysicalAddressType: '1',
    PostalAddressType: '2',
    RegisteredAddressType: '3'
} as const;
export type IAPADDRESSTYPE = typeof IAPADDRESSTYPE[keyof typeof IAPADDRESSTYPE];


export function IAPADDRESSTYPEFromJSON(json: any): IAPADDRESSTYPE {
    return IAPADDRESSTYPEFromJSONTyped(json, false);
}

export function IAPADDRESSTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPADDRESSTYPE {
    return json as IAPADDRESSTYPE;
}

export function IAPADDRESSTYPEToJSON(value?: IAPADDRESSTYPE | null): any {
    return value as any;
}

